import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { TextFieldSts } from "staysure-component-library";

import RichText from "@/components/atoms/rich-text/rich-text";
import { RootState } from "@/store/root-reducer";
import { PassportIdSectionProps } from "@/types/review-types";
import { validatePassportId } from "@/utils/review.utils";

import Styles from "./passport-id-block.module.css";

function PassportIdSection({
  passportSectionTitle,
  passportSectionDescription,
  passportIdPlaceholder,
  inputPassportIdErrorEmpty,
  inputPassportIdErrorInvalid,
  setPassportId,
}: Readonly<PassportIdSectionProps>) {
  const [valuePassportId, setValuePassportId] = useState<string>("");
  const [passportIdErrors, setPassportIdErrors] = useState<string>("");
  const { attributes } = useSelector((state: RootState) => state.quote);

  useEffect(() => {
    const passportId = attributes.paymentDetails?.passportId;
    setValuePassportId(passportId || "");
    setPassportId(passportId || "");
  }, [attributes.paymentDetails?.passportId, setPassportId]);

  const handleInputChange = (passportId: string) => {
    const errors = validatePassportId(
      passportId,
      inputPassportIdErrorEmpty,
      inputPassportIdErrorInvalid
    );
    if (errors !== "") {
      setPassportIdErrors("");
      setPassportId("");
    } else {
      setPassportId(passportId);
    }
  };

  const handleBlur = (passportId: string) => {
    const errors = validatePassportId(
      passportId,
      inputPassportIdErrorEmpty,
      inputPassportIdErrorInvalid
    );

    if (errors !== "") {
      setPassportIdErrors(errors);
      setPassportId("");
    } else {
      setPassportIdErrors("");
      setValuePassportId(passportId);
      setPassportId(passportId);
    }
  };

  return (
    <main className="PassportIdSection" data-testid="passportIdSection-test-id">
      <div className="font-body-font">
        <div
          className=" font-header-font font-[700] md:text-[25px] text-[23px] 
          md:leading-[28px] leading-[26px] text-text-title  md:text-left mb-spacing-m"
        >
          {passportSectionTitle}
        </div>
        <div className={`${Styles.list_block} `}>
          <RichText
            richText={passportSectionDescription}
            className={`${Styles.richtext}`}
            data-testid="richText-testid"
          />
        </div>
        <div
          className={`${Styles.input_wrapper} flex flex-row items-start mt-spacing-s`}
        >
          <TextFieldSts
            name="valuePassportId"
            label={passportIdPlaceholder}
            data-testid="passport-id-organiser"
            id="passport-id-organiser"
            aria-label="passport-id-organiser"
            width="100%"
            maxLength={12}
            state={passportIdErrors ? "error" : undefined}
            message={passportIdErrors ? "Please enter a valid passport ID" : ""}
            value={valuePassportId}
            onChange={(value) => handleInputChange(value)}
            onBlur={(event) => handleBlur(event.target.value)}
          />
        </div>
      </div>
    </main>
  );
}

export default PassportIdSection;
